export const fsHash = '#fs';
